import { Observable } from "rxjs";
import { EventRequestById } from "../../models/event";
import { IApiErrorSuccessDTO } from "../../models/apiErrorSuccess";
import { RequestSourceTypeEnum } from "../../models/request";
import { IEventPropertiesDTO } from "./event-api.service";

export abstract class EventApi {
  public abstract getEventsByWorkorderId(
    id: number,
  ): Observable<EventRequestById[]>;
  public abstract addEventByWorkorderId(
    id: number,
    event: EventRequestById,
  ): Observable<EventRequestById>;
  public abstract postTakeInCharge(
    ids: number[],
    responsibleUser?: string,
  ): Observable<IApiErrorSuccessDTO>;
  public abstract postCancelTakeInCharge(
    ids: number[],
  ): Observable<IApiErrorSuccessDTO>;
  public abstract postChangeActivity(
    eventProperties: IEventPropertiesDTO,
  ): Observable<IApiErrorSuccessDTO>;
  public abstract postChangeResponsible(
    ids: number[],
    responsibleUser: string,
    requestType: RequestSourceTypeEnum,
  ): Observable<IApiErrorSuccessDTO>;
  public abstract postCloseWorkorder(
    eventProperties: IEventPropertiesDTO,
  ): Observable<IApiErrorSuccessDTO>;
}
